import { CSSProperties } from 'react';

export function btnPaddingStyle(
  defaultPadding: number,
  additionnalPadding: number,
  btnPosition: 'left' | 'right'
): CSSProperties {
  let padding: string = `${defaultPadding}px`;

  if (additionnalPadding > 0) {
    if (btnPosition === 'left') {
      padding = `${defaultPadding}px ${defaultPadding +
        additionnalPadding}px ${defaultPadding +
        additionnalPadding}px ${defaultPadding}px`;
    } else {
      padding = `${defaultPadding}px ${defaultPadding}px ${defaultPadding +
        additionnalPadding}px ${defaultPadding + additionnalPadding}px`;
    }
  }

  return { padding };
}

export function btnPositionStyle(position: 'left' | 'right'): CSSProperties {
  return {
    left: position === 'left' ? 0 : 'auto',
    right: position === 'right' ? 0 : 'auto'
  };
}
